import classNames from 'classnames/bind';
import React, { PureComponent } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import styles from './Steps.scss';

const cs = classNames.bind(styles);

/**
 * Numeric input for answerPrice; enforces 0–1000 and propagates every keystroke to parent
 */
export class AnswerPrice extends PureComponent {
  render() {
    const {
      answerIndex,
      disabled,
      answerPrice,
      activeStepsFunc,
      handleChange,
      xs,
      stepIndex,
      xl,
      sm,
      lg,
      label = 'Price ♥',
      name = `steps[${stepIndex}][answers][${answerIndex}][answerPrice]`,
      ...rest
    } = this.props;

    const onValueChange = (value) => {
      const val = value === '' ? 0 : Math.min(1000, Math.max(0, parseInt(value, 10) || 0));
      handleChange(val);
    };

    const handleChangeEvent = (e) => {
      onValueChange(e.target.value);
    };

    return (
      <Form.Group
        xs={xs || 12}
        sm={sm || 5}
        lg={lg || 4}
        xl={xl || 4}
        as={Col}
        controlId={`answerPrice${answerIndex}`}
        className={cs('mb-0')}
      >
        <Row>
          <Form.Label
            className="text-right px-1"
            column
            sm={5}
            xl={7}
          >
            {label}
          </Form.Label>
          <Col className={cs('mb-0 px-1')}>
            <Form.Control
              disabled={disabled}
              size="sm"
              type="number"
              min={0}
              max={1000}
              value={answerPrice != null ? answerPrice : 0}
              name={name}
              onFocus={() => activeStepsFunc?.(`steps-${stepIndex}-answers-${answerIndex}-answerPrice`)}
              onMouseDown={(e) => e.stopPropagation()}
              onInput={handleChangeEvent}
              onChange={handleChangeEvent}
              data-testid={name}
              {...rest}
            />
          </Col>
        </Row>
      </Form.Group>
    );
  }
}
